// Register
const successRegisterText =
  'We’ll send you a confirmation email to verify that the address is correct. Please follow the link to complete the registration.';
const errorRegisterText = 'Registration failed. This email may already be in use or not verified.';
// Login
const errorLoginText = 'Login failed. Please check your credentials and try again.';
const errorVerifyCodeText = 'Invalid verification code. Please try again.';
const successVerificationCodeSentText = 'Verification code has been sent to your email.';
// Forgot Password
const errorForgotPasswordText = 'Password reset failed. Please check your email and try again.';
const successForgotPasswordText = 'Check your inbox for a password reset email.';
// Change Password
const errorChangePasswordText =
  'Failed to change password. Please try again.Password reset failed. Please check your email and try again.';
const successChangePasswordText = 'Your password has been changed successfully.';
// Add Supplier
const successAddSupplierText = 'Supplier has been successfully added.';
const errorAddSupplierText = 'Failed to add the supplier. Please try again';
// Edit Supplier
const successEditSupplierText = 'Supplier has been successfully updated.';
const errorEditSupplierText = 'Failed to update the supplier. Please try again';
// Delete Supplier
const successDeleteSupplierText = 'Supplier has been successfully deleted.';
const errorDeleteSupplierText = 'Failed to delete the supplier. Please try again';
// Create New RFP
const successCreateNewRFPText = 'Your Request for Proposal was created successfully.';
const errorCreateNewRFPText = 'Failed to create the Request for Proposal. Please try again.';
// Delete RFP
const successDeleteRFPText = 'RFP has been successfully deleted.';
const errorDeleteRFPText = 'Failed to delete the RFP. Please try again';
// Clone RFP
const successCloneRFPText = 'RFP has been successfully copied.';
const errorCloneRFPText = 'Failed to clone the RFP. Please try again';
// Delete Document
const successDeleteDocumentText = 'Document has been successfully deleted.';
const errorDeleteDocumentText = 'Failed to delete the document. Please try again';

// View Document
const errorViewDocumentText = 'Failed to load the document. Please try again';

// Add Category
const successAddCategoryText = 'Category has been successfully added.';
const errorAddCategoryText = 'Failed to add the category. Please try again';
// Edit Category
const successEditCategoryText = 'Category has been successfully updated.';
const errorEditCategoryText = 'Failed to update the category. Please try again';
// Delete Category
const successDeleteCategoryText = 'Category has been successfully deleted.';
const errorDeleteCategoryText = 'Failed to delete the category. Please try again';

// Add Question
const successAddQuestionText = 'Question has been successfully added.';
const errorAddQuestionText = 'Failed to add the question. Please try again';
// Edit Question
const successEditQuestionText = 'Question has been successfully updated.';
const errorEditQuestionText = 'Failed to update the question. Please try again';
// Delete Question
const successDeleteQuestionText = 'Question has been successfully deleted.';
const errorDeleteQuestionText = 'Failed to delete the question. Please try again';

// Add Invite Supplier
const successAddInviteText = 'Supplier has been successfully invited.';
const errorAddInviteText = 'Failed to invite the supplier. Please try again';

// Remove Invite Supplier
const successRemoveInviteText = 'Invite has been successfully removed.';
const errorRemoveInviteText = 'Failed to remove the invite. Please try again';

// Add Answer to Question
const successAddAnswerToQuestionText = 'Answer has been successfully added.';
const errorAddAnswerToQuestionText = 'Failed to add answer. Please try again';

// No-Bid Question
const successNoBidToQuestionText = 'No-Bid has been successfully send.';
const errorNoBidToQuestionText = 'Failed to No-Bid answer. Please try again';
// Delete Question
const successDeleteAnswerText = 'Answer has been successfully deleted.';
const errorDeleteAnswerText = 'Failed to delete the answer. Please try again';

// Document
const errorAddDocumentText = 'File size should be less than 5MB!';
const successEditProfileText = 'The profile information has been successfully updated.';

// No Bit Invite
const successNoBidSubmitInviteText = 'No-Bid has been successfully send.';
const errorNoBidSubmitInviteText = 'Failed to No-Bid. Please try again';

// Submit RFP
const successSubmitNewRFPText = 'Your Request for Proposal was submitted successfully.';
const errorSubmitNewRFPText = 'Failed to submit the Request for Proposal. Please try again.';

// Submit Invite
const successSubmitInviteText = 'Your response was submitted successfully.';
const errorSubmitInviteText = 'Failed to submit. Please try again.';

// Submit Invite
const successAcceptInviteText = 'Invite was accepted successfully.';
const errorAcceptInviteText = 'Failed to accept. Please try again.';

// Submit Invite
const successRejectInviteText = 'Invite was rejected successfully.';
const errorRejectInviteText = 'Failed to reject. Please try again.';

export {
  successRegisterText,
  errorRegisterText,
  errorLoginText,
  successVerificationCodeSentText,
  errorVerifyCodeText,
  errorForgotPasswordText,
  errorAddDocumentText,
  successForgotPasswordText,
  successEditProfileText,
  errorChangePasswordText,
  successChangePasswordText,
  successAddSupplierText,
  errorAddSupplierText,
  successEditSupplierText,
  errorEditSupplierText,
  successDeleteSupplierText,
  errorDeleteSupplierText,
  successCreateNewRFPText,
  errorCreateNewRFPText,
  successDeleteDocumentText,
  errorDeleteDocumentText,
  errorViewDocumentText,
  successDeleteRFPText,
  errorDeleteRFPText,
  successAddCategoryText,
  errorAddCategoryText,
  successEditCategoryText,
  errorEditCategoryText,
  successDeleteCategoryText,
  errorDeleteCategoryText,
  successAddQuestionText,
  errorAddQuestionText,
  successEditQuestionText,
  errorEditQuestionText,
  successDeleteQuestionText,
  errorDeleteQuestionText,
  successRemoveInviteText,
  errorRemoveInviteText,
  successAddInviteText,
  errorAddInviteText,
  successAddAnswerToQuestionText,
  errorAddAnswerToQuestionText,
  successNoBidToQuestionText,
  errorNoBidToQuestionText,
  successNoBidSubmitInviteText,
  errorNoBidSubmitInviteText,
  successSubmitNewRFPText,
  errorSubmitNewRFPText,
  successSubmitInviteText,
  errorSubmitInviteText,
  successDeleteAnswerText,
  errorDeleteAnswerText,
  successAcceptInviteText,
  errorAcceptInviteText,
  successRejectInviteText,
  errorRejectInviteText,
  successCloneRFPText,
  errorCloneRFPText
};
